/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import type { PathPattern } from 'react-router-dom'

/**
 * Convenience method for matching a partial path with `react-router#matchPath`.
 *
 * @example
 *
 *   mathPath('/abc', '/abc/def')
 *   => falsy
 *
 *   matchPath(startingWith('/abc'), '/abc/def')
 *   => truthy
 */
export const startingWith = (path: string): PathPattern => ({
  path,
  end: false,
})
